import { PropsWithChildren } from "react";
import useIsLoggedIn from "ui/auth/hooks/useIsLoggedIn";
import { AuthRoutes } from "ui/auth/router/AuthRouter.types";
import ProtectedRoute from "ui/router/components/ProtectedRoute/ProtectedRoute";

const LoggedInRoute = ({ children }: PropsWithChildren<object>): JSX.Element => {
    const isLoggedIn = useIsLoggedIn();

    return (
        <ProtectedRoute isAllowed={isLoggedIn} redirectPath={AuthRoutes.LOGIN}>
            {children}
        </ProtectedRoute>
    );
};

export default LoggedInRoute;
